import {
  Actions,
  Box,
  ButtonLink,
  Divider,
  Heading,
  Hidden,
  Page,
  PageBlock,
  Stack,
  Text,
} from 'braid-design-system';
import queryString from 'query-string';
import { useLocation, useParams } from 'react-router-dom';

import Header from 'src/components/Header/Header';
import { SiteWideFooter } from 'src/components/SiteWideFooter';

const RecommendationUnsubscribe = () => {
  const { id } = useParams();
  const urlLocation = useLocation();
  const { token } = queryString.parseUrl(urlLocation.search).query;

  return (
    <Page footer={<SiteWideFooter />} footerPosition="belowFold">
      <Header title="Buying a business" />

      <Hidden below="tablet">
        <Divider />
      </Hidden>

      <Box paddingTop="xlarge">
        <PageBlock width="small">
          <Stack space="large">
            <Stack space="medium">
              <Heading level="2">Before you go!</Heading>

              <Text>
                Did you know you can manage your preferences? You can now manage
                the type of business recommendations we email you. This way
                you&apos;ll only receive businesses that match your criteria
                (that is, businesses that you&apos;ll actually be interested
                in!).
              </Text>
            </Stack>

            <Actions>
              <ButtonLink
                href={`/buyer/preferences?token=${token}`}
                tone="formAccent"
              >
                Manage my preferences
              </ButtonLink>

              <ButtonLink variant="ghost" href={`/unsubscribe/${id}`}>
                No thanks, unsubscribe me
              </ButtonLink>
            </Actions>
          </Stack>
        </PageBlock>
      </Box>
    </Page>
  );
};

export default RecommendationUnsubscribe;
